function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n   * {\n        padding: 0;\n        margin: 0;\n        box-sizing: border-box;\n    }\n\n    ::before, ::after {\n        box-sizing: inherit;\n    }\n    \n    html, body {\n        font-family: Montserrat;\n        background-color: #f7f7f7;\n        margin: 0;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { createGlobalStyle } from 'styled-components';
export var BrandingHexColors = /*#__PURE__*/ function(BrandingHexColors) {
    BrandingHexColors["BUILDERS_BLUE"] = "#00205B";
    BrandingHexColors["PARADIGM_GREEN"] = "#159A49";
    return BrandingHexColors;
}({});
export var GlobalStyle = createGlobalStyle(_templateObject());
